module.exports = __webpack_public_path__ + "img/videowiki.31702adc.svg";